import React, { useState } from "react";
import { Trash2, X, AlertTriangle } from "lucide-react";
import { showLoading, showSuccess, showError } from "../../../utils/toastUtils";
import toast from "react-hot-toast";

const BannerDeleteModal = ({ isOpen, onClose, banner, onConfirm }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  if (!isOpen || !banner) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-md w-full p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="bg-red-100 p-3 rounded-full">
            <AlertTriangle className="text-red-600" size={28} />
          </div>
          <h2 className="text-2xl font-bold text-gray-900">Delete Banner</h2>
        </div>

        <p className="text-gray-600 mb-6">
          Are you sure you want to delete the banner{" "}
          <span className="font-semibold">"{banner.title}"</span>?
          <br />
          This action <strong>cannot be undone</strong>.
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-5 py-2 border border-gray-300 rounded-lg hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={async () => {
              setIsDeleting(true);
              const loadingId = showLoading("Deleting banner...");
              try {
                await onConfirm(banner.id);
                if (loadingId) toast.dismiss(loadingId);
                showSuccess("Banner deleted");
                onClose();
              } catch (err) {
                if (loadingId) toast.dismiss(loadingId);
                showError(err?.message || "Failed to delete banner");
              } finally {
                setIsDeleting(false);
              }
            }}
            disabled={isDeleting}
            className={`px-5 py-2 bg-red-600 text-white rounded-lg ${isDeleting ? 'opacity-50 cursor-not-allowed' : 'hover:bg-red-700'} flex items-center gap-2`}
          >
            <Trash2 size={18} />
            {isDeleting ? 'Deleting...' : 'Delete Banner'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BannerDeleteModal;